export default __webpack_public_path__ + "static/IBMPlexSans-Medium-737a89d010c64ac327a04f0df7a6e121.woff";